module.exports = __webpack_public_path__ + "static/media/zero.8d1d9bef.png";